import { Counterparty } from '~/repositories';
import { AccountNumber, BankAccount } from '~/repositories/BankAccountRepository';
import { ACHTransferBatch, ApiAddress, TransferBatch, TransferReview } from '~/typings/API';

export enum TimelineStatus {
  Success = 'success',
  Danger = 'danger',
  InProgress = 'in-progress',
  Pending = 'pending',
  Warning = 'warning',
  Returned = 'returned',
}

export enum TimelinePartyType {
  Sender = 'sender',
  Receiver = 'receiver',
}

export interface TimelineEntry {
  label: string;
  amount?: TransferAmount;
  batch?: TransferBatch;
  achBatch?: ACHTransferBatch;
  isAdding?: boolean;
  status?: TimelineStatus;
  link?: {
    label: string;
    path: string;
  };
  date?: Date | string;
  outerCard?: React.ReactNode;
  partyData?: TransferParty;
  returnData?: TransferReturn;
  internationalWireReturnData?: TransferInternationalWireReturn;
  reviewData?: TransferReview[];
}

export interface TransferAmount {
  value: number;
  isAdding: boolean;
  currencyCode: string;
  settledAmount?: number;
  settledCurrencyCode?: string;
  partyType?: 'sender' | 'receiver';
  instructedCurrencyCode?: string;
  instructedAmount?: number;
  isIncoming?: boolean;
}

export interface TransferParty {
  data: TransferBankAccount | TransferCounterparty | TransferCompany | TransferCheckPayee | TransferAdminParty;
  partyType: TimelinePartyType;
  metadata?: string;
}

export interface TransferBankAccount {
  bankAccount: BankAccount;
  accountNumber: AccountNumber;
  entityType?: 'person' | 'business';
  isBookTransfer?: boolean;
  frontImage?: string;
  backImage?: string;
}

export interface TransferCounterparty {
  counterparty: Counterparty;
}

export interface TransferCompany {
  companyId: string;
  companyName: string;
}

export interface TransferCheckPayee {
  payeeName: string;
  deliveredByColumn: boolean;
  payeeAddress: ApiAddress;
  frontImage?: string;
  backImage?: string;
  deliveryMethod?: string | null;
  deliveryStatus?:
    | 'created'
    | 'rendered_pdf'
    | 'renderedPdf'
    | 'mailed'
    | 'in_transit'
    | 'inTransit'
    | 'in_local_area'
    | 'inLocalArea'
    | 'processed_for_delivery'
    | 'processedForDelivery'
    | 'delivered'
    | 'failed'
    | 'rerouted'
    | 'returned_to_sender'
    | 'returnedToSender'
    | 'rejected'
    | 'international_exit'
    | 'internationalExit';
}

export interface TransferAdminParty {
  adminName: string;
}

export type TransferReturn = {
  addenda?: string;
  code: string;
  description: string;
  amount?: number;
  currencyCode?: string;
} & {
  reason: string;
  description?: string;
};

export type TransferInternationalWireReturn = {
  reason: string;
  amount: number;
  currencyCode: string;
};
